import { deepMerge, isObject } from "@/libs/lodash"
import { derived, writable } from "svelte/store"

/** @returns Svelte store to access */
export const create = <T extends NestedDictionary<string>>(messages: T) => {
  const messagesStore = writable(messages)

  const defaultNamespace = writable("")

  // This store helps to extend/override the default messages with a new custom messages
  // Needs to have different messages for “front” and “back” camera use cases
  const { subscribe } = derived(
    [messagesStore, defaultNamespace],
    ([$messagesStore, $defaultNamespace]): T => {
      if ($defaultNamespace && isObject($messagesStore[$defaultNamespace]))
        return deepMerge({}, $messagesStore, $messagesStore[$defaultNamespace])

      return $messagesStore
    },
  )

  const add = <T extends NestedDictionary<string>>(messages: T) => {
    if (Object.keys(messages).length === 0) return

    messagesStore.update((s) => deepMerge({}, s, messages))
  }

  const setDefaultNamespace = (namespace: string) => defaultNamespace.set(namespace)

  return { subscribe, add, setDefaultNamespace }
}
